module.exports = __webpack_public_path__ + "img/Mage-bloodelf-f-70.24e54ade.gif";